import { ClientSecretInput } from "@arcadeai/design-system/components/ui/molecules/client-secret-field";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control, FieldValues, Path } from "react-hook-form";

type ClientSecretFormFieldProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  isEditing?: boolean;
};

export function ClientSecretFormField<T extends FieldValues>({
  control,
  name,
  isEditing = false,
}: ClientSecretFormFieldProps<T>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            Client Secret
            {!isEditing && <span className="text-destructive"> *</span>}
            {isEditing && (
              <span className="ml-2 font-normal text-muted-foreground text-xs">
                Optional
              </span>
            )}
          </FormLabel>
          <FormControl>
            <ClientSecretInput
              {...field}
              mode={isEditing ? "rotate" : "create"}
              secretIsSet={isEditing}
              value={field.value ?? ""}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
